
import store from '../store/store';
import { IBookingType, IChatType, IUserType } from '../types';
import { firebase } from '../config/firebase.client';
import { RequestPushMsg } from '../other/NotificationFunctions';
import { onValue, push, off, child, update } from "firebase/database";
import { FETCH_MESSAGES, FETCH_MESSAGES_SUCCESS, FETCH_MESSAGES_FAILED, SEND_MESSAGE, STOP_FETCH_MESSAGES } from "../store/types";

export const fetchChatMessages = (bookingId: IBookingType['id']) => (dispatch: any) => {

  const {
    chatRef
  } = firebase;

  dispatch({
    type: FETCH_MESSAGES,
    payload: bookingId,
  });

  onValue(chatRef(bookingId), snapshot => {
    if (snapshot.val()) {
      let rootEntry = snapshot.val();
      let allMesseges = [];
      for (let key in rootEntry) {
        let entryKey = rootEntry[key]
        for (let msgKey in entryKey) {
          entryKey[msgKey].smsId = msgKey
          allMesseges.push(entryKey[msgKey])
        }
      }
      dispatch({
        type: FETCH_MESSAGES_SUCCESS,
        payload: allMesseges,
      });
    } else {
      dispatch({
        type: FETCH_MESSAGES_FAILED,
        payload: store.getState().languagedata.defaultLanguage.chat_not_found,
      });
    }
  })
};

export const sendMessage = (data: Partial<IChatType>) => (dispatch: any) => {

  const {
    chatRef
  } = firebase;

  const chatId = data?.booking?.customer + ',' + data?.booking?.driver
  var today: any = new Date();
  var time = today.getHours() + ":" + today.getMinutes();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0');
  var yyyy = today.getFullYear();
  today = mm + ':' + dd + ':' + yyyy;

  const msg = {
    message: data.message,
    from: data.role == 'customer' ? data?.booking?.customer : data?.booking?.driver,
    type: "msg",
    msgDate: today,
    msgTime: time,
    createdAt: new Date().toString(),
    source: data.role
  };

  push(child(chatRef(data?.booking?.id!), chatId), msg);

  if (data.role == 'customer') {
    if (data?.booking?.driver_token && data?.booking?.driver_token !== 'token_error') {
      RequestPushMsg(
        data?.booking?.driver_token,
        {
          title: store.getState().languagedata.defaultLanguage.notification_title + store.getState().languagedata.defaultLanguage.chat_requested,
          msg: data.message,
          screen: 'onlineChat',
          params: { bookingId: data?.booking?.id }
        });
    }
  } else {
    if (data?.booking?.customer_token && data?.booking?.customer_token !== 'token_error') {
      RequestPushMsg(
        data?.booking?.customer_token,
        {
          title: store.getState().languagedata.defaultLanguage.notification_title + store.getState().languagedata.defaultLanguage.chat_requested,
          msg: data.message,
          screen: 'onlineChat',
          params: { bookingId: data?.booking?.id }
        });
    }
  }

  dispatch({
    type: SEND_MESSAGE,
    payload: msg,
  });
}

export const stopFetchMessages = (bookingId: IBookingType['id']) => (dispatch: any) => {

  const {
    chatRef
  } = firebase;

  dispatch({
    type: STOP_FETCH_MESSAGES,
    payload: bookingId,
  });
  off(chatRef(bookingId));
}

export const markAllMessagesAsSeen = (bookingId: IBookingType['id'], userId: IUserType['id']) => {
  const { chatRef } = firebase;

  return new Promise((resolve, reject) => {
    onValue(chatRef(bookingId), (snapshot) => {
      try {
        if (!snapshot.exists()) {
          resolve(false);
          return;
        }

        const messagesData = snapshot.val();
        const updates: any = {};
        const now = new Date().toISOString();
        let count = 0;

        for (const chatKey in messagesData) {
          for (const msgKey in messagesData[chatKey]) {
            const message = messagesData[chatKey][msgKey];

            if (message.from !== userId && message.seen !== true) {
              updates[`${chatKey}/${msgKey}/seen`] = true;
              updates[`${chatKey}/${msgKey}/seenAt`] = now;
              updates[`${chatKey}/${msgKey}/seenBy`] = userId;
              count++;
            }
          }
        }
        if (count > 0) {
          update(chatRef(bookingId), updates)
            .then(() => {
              resolve(count);
            })
            .catch(error => {
              console.error('❌ Erro ao marcar mensagens:', error);
              reject(error);
            });
        } else {
          resolve(0);
        }

      } catch (error) {
        console.error('❌ Erro no processamento:', error);
        reject(error);
      }
    }, { onlyOnce: true });
  });
};